import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";
import socket from "../../../../Socket";
import {
  __,
  addNewStyle,
  CRISTP_ID,
  decode,
  defaultAvatar,
  encode,
  getUID,
  sendNotfication,
  toUSD,
  wait,
} from "../../../../Helper";
import UserModal from "../../../Components/User/Stat/Modal";
import C from "../../../../Constant";
import {
  Dropdown,
  ButtonGroup,
  Form,
  Modal,
  Spinner,
  Image,
  Table,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { ArrowUpFromDot, X } from "lucide-react";
import ManualDeposit from "./ManualDeposit";
import axios from "axios";
import { Select } from "@mui/material";
import Cookies from "js-cookie";
import Withdrawpayment from "./Withdrawpayment";

// All existing styled components remain the same...
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const Button = styled.button`
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 10px 15px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
  flex: 1;
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    background-color: #0056b3;
  }

  &.active {
    background-color: #0056b3;
  }
`;

const Input = styled.input`
  margin: 5px 0;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  margin-bottom: 20px;
`;

const Container = styled.div`
  background-color: #1e2024;
  padding: "20px";
  border-radius: 26px;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
`;

const CubBalance = styled.div`
  color: #99999;
  font-size: 14px;
  font-weight: bold;
  margin-right: 10px;
`;

const ModalTop = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
const StyledModal = styled(Modal)`
  .modal-content {
    background-color: #17181b;
    border-radius: 15px;
    border: none;
  }
  .modal-dialog {
    @media (min-width: 576px) {
      max-width: 90%;
      width: 400px;
    }
    @media (min-width: 768px) {
      max-width: 85%;
      width: 500px;
    }
    @media (min-width: 992px) {
      max-width: 80%;
      width: 600px;
    }
    @media (min-width: 1200px) {
      max-width: 75%;
      width: 900px;
    }
  }
`;
const ModalBody = styled(Modal.Body)`
  padding: 0 20px 20px;
  background-color: #17181b;
`;

const ModalHeader = styled(Modal.Header)`
  border-bottom: none;
  padding: 20px;
`;

const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const InputContainer = styled.div`
  margin-bottom: 20px;
`;

const StyledButtonNew = styled.button`
  background-color: rgb(255, 168, 0);
  color: white;
  font-weight: bold;
  padding: 0.75rem 1.5rem;
  border-radius: 9999px;
  width: 100%;
  max-width: 20rem;
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: rgb(255, 168, 0);
    transform: scale(1.05);
  }
`;

const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  color: #a0a0a0;
  font-family: normal;
`;

const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const StyledButton = styled(Button)`
  background-color: ${(props) => (props.primary ? "#6C5CE7" : "#4A4D56")};
  border: none;
  border-radius: 10px;
  color: #fff;
  font-weight: bold;
  padding: 12px;
  margin-bottom: 10px;
  transition: all 0.3s ease;

  &:hover,
  &:focus {
    background-color: ${(props) => (props.primary ? "#5849C2" : "#3A3D46")};
  }
`;

const HertContainer = styled.div`
  background-color: #1c1d21;
  padding: 0px 0.75rem;
  border-radius: 20px;
`;
const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
const FlexContainerStar = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
`;

const Pencil = styled.div`
display:flex;
justify-content:center
background-color:#1C1D21;
padding: 0.75rem;
border-radius:50%;
`;

const UserContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 5px;
  padding: 5px;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  background-color: #1e1e1e;
  padding: 20px;
  border-radius: 8px;
  max-width: 300px;
`;

const GridItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  color: #ffffff;
  font-size: 14px;
`;

const IconWrapper = styled.div`
  margin-right: 10px;
`;

const MenuContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const MenuItem = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  width: 100%;
  margin-right: 12px;
  align-items: center;
`;

const MenuItemContent = styled.div`
  color: #676f78;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 5px 12px;
  border-radius: 20px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #222428;
  }
`;

const IconWrapperNew = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
`;

const StyledImg = styled.img`
  height: 18px;
  width: 18px;
  filter: invert(48%) sepia(6%) saturate(426%) hue-rotate(167deg)
    brightness(94%) contrast(87%);
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;

  &:hover {
    opacity: 0.8;
  }
`;

const ProgressBarContainer = styled.div`
  background-color: #1e2024;
  border-radius: 20px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const ProgressBarText = styled.span`
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
`;

const ProgressBarWrapper = styled.div`
  background-color: #424a55;
  border-radius: 20px;
  height: 8px;
  width: 85%;
`;

const ProgressBarFill = styled.div`
  background-color: #ffffff;
  border-radius: 10px;
  height: 100%;
  width: ${(props) => props.progress}%;
`;

// New Improved Styled Components
const MainContainer = styled.div`
  background-color: #17181b;
  color: white;
  padding: 24px;
  border-radius: 16px;
  width: 100%;
  min-height: 500px;
  @media (max-width: 500px) {
    padding: 10px;
  }
`;

const LayoutContainer = styled.div`
  display: flex;
  gap: 24px;

  @media (max-width: 1149px) {
    flex-direction: column;
    gap: 16px;
  }

  @media (min-width: 1150px) {
    flex-direction: row;
  }
`;

const SidebarContainer = styled.div`
  @media (max-width: 1149px) {
    width: 100%;
    order: 1;
  }

  @media (min-width: 1150px) {
    width: 280px;
    flex-shrink: 0;
    order: 1;
  }
`;

const ContentArea = styled.div`
  @media (max-width: 768px) {
    width: 100%;
    order: 2;
  }

  @media (min-width: 769px) {
    flex: 1;
    order: 2;
  }
`;

const TabButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: #1e2024;
  padding: 16px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
`;

const TabButton = styled.button`
  padding: 16px 20px;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: left;
  position: relative;
  overflow: hidden;

  ${(props) =>
    props.active
      ? `
        background: linear-gradient(90deg, rgb(255, 215, 0), rgb(255, 140, 0));
color: white;
transform: translateX(4px);
box-shadow: rgb(255, 168, 0) 0px -2px 0px inset;

      `
      : `
        background-color: #2a2d33;
        color: #9ca3af;
        &:hover {
          background-color: #3a3d46;
          color: white;
          transform: translateX(2px);
        }
      `}

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 4px;
    background: ${(props) => (props.active ? "#ffffff" : "transparent")};
    border-radius: 0 4px 4px 0;
  }
`;

const DataContainer = styled.div`
  background-color: #1e2024;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  min-height: 400px;

  @media (max-width: 600px) {
    padding: 0px;
  }
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 16px;

  th {
    background-color: #2a2d33;
    color: #9ca3af;
    padding: 16px 12px;
    text-align: left;
    font-weight: 600;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 2px solid #3a3d46;

    &:first-child {
      border-top-left-radius: 12px;
    }

    &:last-child {
      border-top-right-radius: 12px;
    }
    @media (max-width: 600px) {
      font-size: 10px;
    }

    @media (max-width: 400px) {
      font-size: 7px;
    }
  }

  td {
    padding: 16px 12px;
    border-bottom: 1px solid #2a2d33;
    color: #ffffff;
    font-size: 14px;

    &:first-child {
      font-weight: 500;
    }
    @media (max-width: 600px) {
      font-size: 10px;
    }
    @media (max-width: 400px) {
      font-size: 7px;
    }
  }

  tr {
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #242730;
    }

    &:last-child td {
      border-bottom: none;
    }
  }

  @media (max-width: 768px) {
    font-size: 12px;

    th,
    td {
      padding: 12px 8px;
    }
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 300px;
  gap: 16px;
  color: #9ca3af;
`;

const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 300px;
  gap: 16px;
  color: #9ca3af;

  img {
    opacity: 0.7;
    filter: grayscale(0.3);
  }

  p {
    font-size: 16px;
    margin: 0;
  }
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
  padding: 16px;
  background-color: #2a2d33;
  border-radius: 12px;
`;

const PaginationButton = styled.button`
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  background-color: ${(props) =>
    props.disabled ? "#3a3d46" : "rgb(255, 168, 0)"};
  color: ${(props) => (props.disabled ? "#6b7280" : "white")};
  font-weight: 600;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #4aba12;
    transform: translateY(-1px);
  }
`;

const PaginationInfo = styled.span`
  color: #9ca3af;
  font-weight: 500;
  margin: 0 16px;

  @media (max-width: 400px) {
    margin: 0 0px;
  }
`;

const StatusBadge = styled.span`
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 8px;
    padding: 4px 8px;
  }

  ${(props) => {
    switch (props.status?.toLowerCase()) {
      case "success":
      case "completed":
        return "background-color: #10b981; color: white;";
      case "pending":
        return "background-color: #f59e0b; color: white;";
      case "failed":
      case "rejected":
        return "background-color: #ef4444; color: white;";
      default:
        return "background-color: #6b7280; color: white;";
    }
  }}
`;

const AmountText = styled.span`
  font-weight: 600;
  color: ${(props) => (props.type === "deposit" ? "#10b981" : "#ef4444")};
`;

// NEW WITHDRAWAL FORM STYLED COMPONENTS
const WithdrawFormContainer = styled.div`
  background-color: #1e2024;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  min-height: 400px;
`;

const WithdrawTitle = styled.h2`
  color: #ffffff;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 24px;
  text-align: center;
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const FormLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #9ca3af;
  font-weight: 500;
`;

const FormInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #2a2d33;
  border-radius: 8px;
  background-color: #17181b;
  color: #ffffff;
  font-size: 16px;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: rgb(255, 168, 0);
  }

  &::placeholder {
    color: #6b7280;
  }

  @media (max-width: 420px) {
    font-size: 13px;
    padding: 5px 6px;
  }
`;

const FormSelect = styled.select`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #2a2d33;
  border-radius: 8px;
  background-color: #17181b;
  color: #ffffff;
  font-size: 16px;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: rgb(255, 168, 0);
  }

  option {
    background-color: #17181b;
    color: #ffffff;
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 14px 20px;
  background: linear-gradient(90deg, rgb(255, 215, 0), rgb(255, 140, 0));
  box-shadow: rgb(255, 168, 0) 0px -2px 0px inset;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 20px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(86, 207, 22, 0.3);
  }

  &:disabled {
    background: #3a3d46;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

const BalanceDisplay = styled.div`
  background-color: #2a2d33;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  text-align: center;
`;

const BalanceText = styled.p`
  color: #9ca3af;
  font-size: 14px;
  margin: 0 0 8px;
`;

const BalanceAmount = styled.p`
  color: rgb(255, 168, 0);
  font-size: 24px;
  font-weight: 700;
  margin: 0;
`;

const ErrorMessage = styled.div`
  background-color: #ef4444;
  color: white;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 16px;
  text-align: center;
  font-weight: 500;
`;

const SuccessMessage = styled.div`
  background-color: #10b981;
  color: white;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 16px;
  text-align: center;
  font-weight: 500;
`;

// WITHDRAWAL FORM COMPONENT WITH USDT SUPPORT
const WithdrawForm = () => {
  const [formData, setFormData] = useState({
    amount: "",
    upiId: "",
    withdrawalMode: "upi",
    bankName: "",
    accountNumber: "",
    ifscCode: "",
    accountName: "",
    phone_no: "",
    usdtWalletAddress: "",
    usdtNetwork: "TRC20", // Default to TRC20
  });
  const [userBalance, setUserBalance] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [withdrawalType, setWithdrawalType] = useState("upi"); // "upi", "bank", or "usdt"

  useEffect(() => {
    // Fetch user balance
    fetchUserBalance();
  }, []);

  const fetchUserBalance = async () => {
    try {
      const uid = getUID || parseFloat(Cookies.get("uid"));
      if (!uid) throw new Error("UID is missing");

      const response = await axios.get(
        `https://api.betbazaar365.com/user-balance`,
        {
          params: { uid },
        }
      );

      console.log("Balance response:", response.data);
      setUserBalance(response.data[0].total_win_amount || 0);
    } catch (err) {
      console.error("Failed to fetch balance", err);
      setUserBalance(0); // fallback to zero
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear messages when user starts typing
    if (error) setError("");
    if (success) setSuccess("");
  };

  const handleWithdrawalTypeChange = (type) => {
    setWithdrawalType(type);
    // Clear form data when switching types
    setFormData({
      amount: "",
      upiId: "",
      withdrawalMode: type,
      bankName: "",
      accountNumber: "",
      ifscCode: "",
      accountName: "",
      phone_no: "",
      usdtWalletAddress: "",
      usdtNetwork: "TRC20",
    });
    setError("");
    setSuccess("");
  };

  const validateUPIForm = () => {
    if (!formData.amount || parseFloat(formData.amount) <= 0) {
      setError("Please enter a valid amount");
      return false;
    }
    if (parseFloat(formData.amount) > userBalance) {
      setError("Insufficient balance");
      return false;
    }
    if (!formData.upiId.trim()) {
      setError("Please enter UPI ID");
      return false;
    }
    return true;
  };

  const validateBankForm = () => {
    if (!formData.amount || parseFloat(formData.amount) <= 0) {
      setError("Please enter a valid amount");
      return false;
    }
    // if (parseFloat(formData.amount) > userBalance) {
    //   setError("Insufficient balance");
    //   return false;
    // }
    if (!formData.bankName.trim()) {
      setError("Please enter Bank Name");
      return false;
    }
    if (!formData.accountNumber.trim()) {
      setError("Please enter Account Number");
      return false;
    }
    if (!formData.accountName.trim()) {
      setError("Please enter Account Name");
      return false;
    }
    if (!formData.ifscCode.trim()) {
      setError("Please enter IFSC Code");
      return false;
    }
    if (!formData.phone_no.trim()) {
      setError("Please enter Phone Number");
      return false;
    }
    return true;
  };

  const validateUSDTForm = () => {
    if (!formData.amount || parseFloat(formData.amount) <= 0) {
      setError("Please enter a valid amount");
      return false;
    }
    if (parseFloat(formData.amount) > userBalance) {
      setError("Insufficient balance");
      return false;
    }
    if (!formData.usdtWalletAddress.trim()) {
      setError("Please enter USDT Wallet Address");
      return false;
    }
    // Basic wallet address validation (length check)
    if (
      formData.usdtWalletAddress.length < 26 ||
      formData.usdtWalletAddress.length > 62
    ) {
      setError("Invalid wallet address format");
      return false;
    }
    if (!formData.usdtNetwork) {
      setError("Please select USDT Network");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate based on withdrawal type
    let isValid = false;
    if (withdrawalType === "upi") {
      isValid = validateUPIForm();
    } else if (withdrawalType === "bank") {
      isValid = validateBankForm();
    } else if (withdrawalType === "usdt") {
      isValid = validateUSDTForm();
    }

    if (!isValid) return;

    setLoading(true);
    setError("");

    try {
      const uid = getUID || parseFloat(Cookies.get("uid"));

      const requestData = {
        uid: String(uid),
        money: parseFloat(formData.amount),
        withdrawal_mode: withdrawalType,
      };

      // Add specific fields based on withdrawal type
      if (withdrawalType === "upi") {
        requestData.upiId = formData.upiId;
        requestData.type = "upi";
      } else if (withdrawalType === "bank") {
        requestData.type = "bank";
        requestData.bank_name = formData.bankName;
        requestData.account_number = formData.accountNumber;
        requestData.account_name = formData.accountName;
        requestData.ifsc_code = formData.ifscCode;
        requestData.phone_no = formData.phone_no;
      } else if (withdrawalType === "usdt") {
        requestData.type = "usdt";
        requestData.usdt_wallet_address = formData.usdtWalletAddress;
        requestData.usdt_network = formData.usdtNetwork;
      }

      const response = await axios.post(
        "https://api.betbazaar365.com/payment/api/withdrawal/manual",
        requestData
      );

      if (response.data.success) {
        setSuccess("Withdrawal request submitted successfully!");
        setFormData({
          amount: "",
          upiId: "",
          withdrawalMode: withdrawalType,
          bankName: "",
          accountNumber: "",
          ifscCode: "",
          accountName: "",
          phone_no: "",
          usdtWalletAddress: "",
          usdtNetwork: "TRC20",
        });
        fetchUserBalance(); // Refresh balance
      } else {
        setError(response.data.message || "Withdrawal request failed");
      }
    } catch (err) {
      console.error("Withdrawal request failed", err);
      setError("Failed to submit withdrawal request. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <WithdrawFormContainer>
      <WithdrawTitle>Withdraw Amount</WithdrawTitle>

      {/* Balance Display */}
      {/* <BalanceDisplay>
        <BalanceText>Available Balance</BalanceText>
        <BalanceAmount>₹{userBalance.toFixed(2)}</BalanceAmount>
      </BalanceDisplay> */}

      {/* Withdrawal Type Selection */}
      <WithdrawalTypeContainer>
        <WithdrawalTypeButton
          active={withdrawalType === "upi"}
          onClick={() => handleWithdrawalTypeChange("upi")}
        >
          {/* <img
            src="assets/images/upipay.png"
            alt="UPI"
            style={{ width: "30px", marginRight: "8px" }}
          /> */}
          UPI Withdrawal
        </WithdrawalTypeButton>
        <WithdrawalTypeButton
          active={withdrawalType === "bank"}
          onClick={() => handleWithdrawalTypeChange("bank")}
        >
          Bank Transfer
        </WithdrawalTypeButton>
        <WithdrawalTypeButton
          active={withdrawalType === "usdt"}
          onClick={() => handleWithdrawalTypeChange("usdt")}
        >
          {/* <img
            src="assets/images/USDT.png"
            alt="USDT"
            style={{ width: "30px", marginRight: "8px" }}
            onError={(e) => {
              e.target.style.display = "none";
              e.target.nextSibling.textContent = "₮ USDT Withdrawal";
            }}
          /> */}
          USDT Withdrawal
        </WithdrawalTypeButton>
      </WithdrawalTypeContainer>

      {/* Currency Display */}
      <CurrencyDisplay>
        <CurrencyLabel>Withdrawal Currency</CurrencyLabel>
        <CurrencyInfo>
          {withdrawalType === "usdt" ? (
            <>
              <img
                src="assets/images/USDT.png"
                alt="USDT"
                style={{ width: "20px", marginRight: "8px" }}
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
              USDT
            </>
          ) : (
            <>
              <img
                src="assets/bcimages/INR.webp"
                alt="INR"
                style={{ width: "20px", marginRight: "8px" }}
              />
              INR
            </>
          )}
        </CurrencyInfo>
      </CurrencyDisplay>

      {/* Messages */}
      {error && <ErrorMessage>{error}</ErrorMessage>}
      {success && <SuccessMessage>{success}</SuccessMessage>}

      {/* Form */}
      <form onSubmit={handleSubmit}>
        {/* Amount Field */}
        <FormGroup>
          <FormLabel>Amount</FormLabel>
          <FormInput
            type="number"
            name="amount"
            placeholder={`Enter Amount${
              withdrawalType === "usdt" ? " (USDT)" : " (INR)"
            }`}
            value={formData.amount}
            onChange={handleInputChange}
            min="1"
            step={withdrawalType === "usdt" ? "0.000001" : "0.01"}
          />
        </FormGroup>

        {/* Conditional Fields based on withdrawal type */}
        {withdrawalType === "upi" ? (
          // UPI Fields
          <FormGroup>
            <FormLabel>UPI ID</FormLabel>
            <FormInput
              type="text"
              name="upiId"
              placeholder="Enter UPI ID"
              value={formData.upiId}
              onChange={handleInputChange}
            />
          </FormGroup>
        ) : withdrawalType === "bank" ? (
          // Bank Fields
          <>
            <FormGroup>
              <FormLabel>Bank Name</FormLabel>
              <FormInput
                type="text"
                name="bankName"
                placeholder="Enter Bank Name"
                value={formData.bankName}
                onChange={handleInputChange}
              />
            </FormGroup>

            <FormGroup>
              <FormLabel>Account Name</FormLabel>
              <FormInput
                type="text"
                name="accountName"
                placeholder="Enter Account Holder Name"
                value={formData.accountName}
                onChange={handleInputChange}
              />
            </FormGroup>

            <FormGroup>
              <FormLabel>Account Number</FormLabel>
              <FormInput
                type="text"
                name="accountNumber"
                placeholder="Enter Account Number"
                value={formData.accountNumber}
                onChange={handleInputChange}
              />
            </FormGroup>

            <FormGroup>
              <FormLabel>IFSC Code</FormLabel>
              <FormInput
                type="text"
                name="ifscCode"
                placeholder="Enter IFSC Code"
                value={formData.ifscCode}
                onChange={handleInputChange}
              />
            </FormGroup>
            <FormGroup>
              <FormLabel>Phone No</FormLabel>
              <FormInput
                type="text"
                name="phone_no"
                placeholder="Enter Phone Number"
                value={formData.phone_no}
                onChange={handleInputChange}
              />
            </FormGroup>
          </>
        ) : (
          // USDT Fields
          <>
            <FormGroup>
              <FormLabel>USDT Network</FormLabel>
              <select
                name="usdtNetwork"
                value={formData.usdtNetwork}
                onChange={handleInputChange}
                style={{
                  width: "100%",
                  padding: "12px",
                  border: "2px solid #2a2d33",
                  color: "white",
                  borderRadius: "8px",
                  fontSize: "16px",
                  backgroundColor: "#17181b",
                }}
              >
                <option style={{ fontSize: "12px" }} value="TRC20">
                  TRC20 (Tron)
                </option>
                {/* <option value="ERC20">ERC20 (Ethereum)</option> */}
                <option style={{ fontSize: "12px" }} value="BEP20">
                  BEP20 (BSC)
                </option>
                {/* <option value="POLYGON">Polygon</option> */}
              </select>
            </FormGroup>

            <FormGroup>
              <FormLabel>USDT Wallet Address</FormLabel>
              <FormInput
                type="text"
                name="usdtWalletAddress"
                placeholder="Enter USDT Wallet Address"
                value={formData.usdtWalletAddress}
                onChange={handleInputChange}
              />
              <small
                style={{
                  color: "#666",
                  fontSize: "12px",
                  marginTop: "4px",
                  display: "block",
                }}
              >
                Make sure the wallet address supports {formData.usdtNetwork}{" "}
                network
              </small>
            </FormGroup>
          </>
        )}

        <SubmitButton type="submit" disabled={loading}>
          {loading
            ? "Processing..."
            : `Submit ${
                withdrawalType === "upi"
                  ? "UPI"
                  : withdrawalType === "bank"
                  ? "Bank"
                  : "USDT"
              } Withdrawal`}
        </SubmitButton>
      </form>

      {/* Withdrawal Rules */}
      <WithdrawalRules>
        <WithdrawalRulesTitle>Withdrawal Guidelines:</WithdrawalRulesTitle>
        {withdrawalType === "usdt" ? (
          <>
            <WithdrawalRule>
              1. USDT withdrawal limit - $10-$1,000 (30min) | Above $1,000
              (24hrs)
            </WithdrawalRule>
            <WithdrawalRule>
              2. Network fees will be deducted from your withdrawal amount
            </WithdrawalRule>
            <WithdrawalRule>
              3. Double-check wallet address and network before submitting
            </WithdrawalRule>
            <WithdrawalRule>
              4. USDT transactions are irreversible once processed
            </WithdrawalRule>
            <WithdrawalRule>
              5. Processing time varies based on network congestion
            </WithdrawalRule>
          </>
        ) : (
          <>
            <WithdrawalRule>
              1. Withdrawal limit - ₹500-₹10,000 (30min) | Above ₹10,000 (24hrs)
            </WithdrawalRule>
            <WithdrawalRule>
              2. Your withdrawal amount will be processed as per the submission
              amount
            </WithdrawalRule>
            <WithdrawalRule>
              3. Each withdrawal request can only be processed once to avoid
              duplicates
            </WithdrawalRule>
            <WithdrawalRule>
              4. Please follow the withdrawal guidelines for smooth processing
            </WithdrawalRule>
          </>
        )}
      </WithdrawalRules>
    </WithdrawFormContainer>
  );
};
// Additional Styled Components for the new features
const WithdrawalTypeContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
`;

const WithdrawalTypeButton = styled.button`
  flex: 1;
  padding: 12px 16px;
  border: 2px solid
    ${(props) => (props.active ? "rgb(255, 168, 0)" : "#2a2d33")};
  border-radius: 8px;
  background: ${(props) =>
    props.active
      ? "linear-gradient(90deg, rgb(255, 215, 0), rgb(255, 140, 0))"
      : "#17181b"};
  box-shadow: ${(props) =>
    props.active ? "rgb(255, 168, 0) 0px -2px 0px inset" : "none"};
  color: ${(props) => (props.active ? "#000" : "#9ca3af")};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: rgb(255, 168, 0);
    background: linear-gradient(90deg, rgb(255, 215, 0), rgb(255, 140, 0));
    box-shadow: rgb(255, 168, 0) 0px -2px 0px inset;
    color: #000;
  }

  @media (max-width: 420px) {
    font-size: 13px;
    padding: 5px 6px;
  }
`;

const CurrencyDisplay = styled.div`
  background-color: #2a2d33;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CurrencyLabel = styled.span`
  color: #9ca3af;
  font-size: 14px;
`;

const CurrencyInfo = styled.div`
  display: flex;
  align-items: center;
  color: #ffffff;
  font-weight: 600;
`;

const WithdrawalRules = styled.div`
  background-color: #2a2d33;
  border-radius: 8px;
  padding: 16px;
  margin-top: 20px;
`;

const WithdrawalRulesTitle = styled.h4`
  color: rgb(255, 168, 0);
  font-size: 16px;
  margin-bottom: 12px;
  font-weight: 600;
`;

const WithdrawalRule = styled.div`
  color: #9ca3af;
  font-size: 13px;
  margin-bottom: 8px;
  line-height: 1.4;

  &:last-child {
    margin-bottom: 0;
  }
`;

// Update the main ModalContent component to also handle the new tab structure
const ModalContent = () => {
  const [activeTab, setActiveTab] = useState("WithdrawForm");
  const [transactionData, setTransactionData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch API data based on the active tab and uid
  const fetchData = async (tab, page) => {
    const uid = getUID || parseFloat(Cookies.get("uid")); // Get UID from your function
    setLoading(true);
    setError(null);
    const req_type = tab === "Deposit" ? "deposit" : "withdrawal";
    try {
      const response = await axios.get(
        `https://api.betbazaar365.com/api/manual-${tab.toLowerCase()}New`,
        {
          params: { uid, req_type, page },
        }
      );
      console.log("API Response manual deposit:", response.data);
      const { data, pagination } = response.data;

      console.log(pagination);
      setCurrentPage(pagination.currentPage || 1);
      setTotalPages(pagination.totalPages || 1);
      setTransactionData(data);
    } catch (err) {
      console.error("API call failed", err);
      setError("Failed to fetch data.");
      setTransactionData([]);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const formatDateTime = (dateString) => {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
    return new Date(dateString).toLocaleDateString(undefined, options); // Format based on locale
  };

  // Fetch data whenever activeTab changes (only for history tabs)
  useEffect(() => {
    if (activeTab === "Deposit" || activeTab === "Withdraw") {
      fetchData(activeTab, currentPage);
    }
  }, [activeTab, currentPage]);

  const renderContent = () => {
    if (activeTab === "WithdrawForm") {
      return <WithdrawForm />;
    }

    // Existing history content
    return (
      <DataContainer>
        {loading ? (
          <LoadingContainer>
            <Spinner animation="border" variant="success" />
            <p>Loading transaction data...</p>
          </LoadingContainer>
        ) : error ? (
          <EmptyStateContainer>
            <p style={{ color: "#ef4444" }}>⚠️ {error}</p>
          </EmptyStateContainer>
        ) : transactionData.length === 0 ? (
          <EmptyStateContainer>
            <Image
              src="/assets/images/emptyPanda.webp"
              style={{
                height: "120px",
                width: "80px",
                objectFit: "contain",
              }}
            />
            <p>No {activeTab.toLowerCase()} transactions found</p>
          </EmptyStateContainer>
        ) : (
          <>
            <StyledTable>
              <thead>
                <tr>
                  <th>Date & Time</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>
                    {activeTab === "Deposit" ? "UTR/Order No" : "UPI/Order No"}
                  </th>
                  <th>
                    {activeTab === "Deposit"
                      ? "Deposit Mode"
                      : "Withdrawal Mode"}
                  </th>
                </tr>
              </thead>
              <tbody>
                {transactionData.map((transaction, index) => (
                  <tr key={index}>
                    <td>{formatDateTime(transaction.transaction_date)}</td>
                    <td>
                      <AmountText type={activeTab.toLowerCase()}>
                        {transaction.transaction_type === "online"
                          ? "₹"
                          : transaction.transaction_type === "CRYPTO"
                          ? "$"
                          : "₹"}
                        {transaction.amount.toFixed(2)}
                      </AmountText>
                    </td>
                    <td>
                      <StatusBadge status={transaction.status}>
                        {transaction.status}
                      </StatusBadge>
                    </td>
                    <td>
                      {transaction?.transaction_type == "UPI" ? (
                        transaction.utr_no
                      ) : transaction?.transaction_type == "CRYPTO" ? (<>
                      {transaction?.crypto?.usdt_network} <br />
                          Address: {transaction.crypto?.usdt_wallet_address} <br />
                      </>) : transaction?.transaction_type == "BANK" ? (
                     <>
                          {transaction.bank.bank_name} <br />
                          A/C: {transaction.bank.account_number} <br />
                          Name: {transaction.bank.account_holder_name}
                       
                      </>) : (
                         transaction?.utr_no
                      )}
                    </td>

                    <td style={{ textTransform: "capitalize" }}>
                      {transaction.transaction_type}
                    </td>
                  </tr>
                ))}
              </tbody>
            </StyledTable>

            {totalPages > 1 && (
              <PaginationContainer>
                <PaginationButton
                  disabled={currentPage === 1}
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  ← Previous
                </PaginationButton>
                <PaginationInfo>
                  Page {currentPage} of {totalPages}
                </PaginationInfo>
                <PaginationButton
                  disabled={currentPage === totalPages}
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next →
                </PaginationButton>
              </PaginationContainer>
            )}
          </>
        )}
      </DataContainer>
    );
  };

  return (
    <MainContainer>
      <LayoutContainer>
        {/* Sidebar with Tab Buttons */}
        <SidebarContainer>
          <TabButtonGroup>
            <TabButton
              active={activeTab === "WithdrawForm"}
              onClick={() => setActiveTab("WithdrawForm")}
            >
              💸 Withdraw Amount
            </TabButton>

            <TabButton
              active={activeTab === "Deposit"}
              onClick={() => setActiveTab("Deposit")}
            >
              💰 Deposit History
            </TabButton>

            <TabButton
              active={activeTab === "Withdraw"}
              onClick={() => setActiveTab("Withdraw")}
            >
              📋 Withdraw History
            </TabButton>
          </TabButtonGroup>
        </SidebarContainer>

        {/* Content Area */}
        <ContentArea>{renderContent()}</ContentArea>
      </LayoutContainer>
    </MainContainer>
  );
};

let order_id;

const DepositModel = () => {
  const [amount, setAmount] = useState("");
  const [utrNumber, setUtrNumber] = useState("");
  const [depositPaymentSetting, setDepositPaymentSetting] = useState({});
  const [step, setStep] = useState(1); // Step 1 for amount entry, Step 2 for QR/UTR entry
  const [depositType, setDepositType] = useState("manual"); // New state for deposit type selection
  const [loading, setLoading] = useState(false);
  // Handle socket connection and submission
  useEffect(() => {
    socket.on(C.SUBMIT_MANUAL_DEPOSIT, (data) => {
      setLoading(false);
      const decodedData = decode(data);
      setManualDeposit(decodedData);
    });

    socket.on(C.SUBMIT_ONLINE_DEPOSIT, (data) => {
      setLoading(false);
      const decodedData = decode(data);
      if (decodedData.data.status === "SUCCESS") {
        window.location.href = decodedData.data.payment_link; // Redirect to payment link
      } else {
        alert("Failed to create payment link", "error");
      }
    });

    socket.emit(
      C.DEPOSIT_PAYMENT_SETTING_INFO,
      encode({
        id: getUID || parseFloat(Cookies.get("uid")),
      })
    );

    socket.on(C.DEPOSIT_PAYMENT_SETTING_INFO, (data) => {
      const settingInfo = decode(data);
      // console.log(settingInfo)
      setDepositPaymentSetting(settingInfo);
    });

    // Clean up the socket listener on component unmount
    return () => {
      socket.off(C.SUBMIT_MANUAL_DEPOSIT);
    };
  }, []);

  const setManualDeposit = (data) => {
    console.log(data);
    if (data.status === true) {
      alert(data.msg, "success", "bottom-left");
    } else {
      alert(data.status, "error", "bottom-left");
    }
  };

  const handleAmountChange = (event) => {
    setAmount(event.target.value);
  };

  const handleUtrChange = (event) => {
    setUtrNumber(event.target.value);
  };

  const handleSubmitAmount = (event) => {
    event.preventDefault();

    // Validate the amount before proceeding to the next step
    if (parseFloat(amount) < 500 || parseFloat(amount) > 49000) {
      sendNotfication(
        "Amount must be between 500 and 49,000",
        "success",
        "bottom-left"
      );
      return;
    }

    setStep(2); // Move to step 2 to show QR and UTR entry
  };

  const handleSubmitDeposit = (event) => {
    event.preventDefault();

    // Validate the amount before submitting the deposit
    if (parseFloat(amount) < 500 || parseFloat(amount) > 49000) {
      sendNotfication(
        "Amount must be between 500 and 49,000",
        "success",
        "bottom-left"
      );
      return;
    }

    setLoading(true);

    const data = {
      id: getUID || parseFloat(Cookies.get("uid")),
      amount: parseFloat(amount),
      utr_no: utrNumber,
      req_type: "deposit",
      status: "pending",
      transaction_type: "manual",
    };

    console.log(data);
    // Emit the socket event to submit deposit
    socket.emit(C.SUBMIT_MANUAL_DEPOSIT, encode(data));
  };

  const handleIndianPayGatewayDeposit = async (event) => {
    event.preventDefault(); // Prevent form submission default behavior
    setLoading(true); // Set loading to true to indicate process start

    try {
      // Sending POST request to the API
      const response = await axios.post(
        "https://api.betbazaar365.com/payment/api/paynow/apihome",
        {
          money: parseFloat(amount),
          uid: getUID || parseFloat(Cookies.get("uid")),
        }
      );

      const data = response?.data;

      // Check if response data is valid
      if (!data) {
        alertMessage("Something went wrong! Please try again.");
        setLoading(false); // Reset loading state
        return;
      }

      // Handle error status from the API
      if (data?.status === false) {
        alertMessage(data?.message || "Payment failed! Please try again.");
        setLoading(false); // Reset loading state
        return;
      }

      console.log(data);

      // Redirect to the provided web URL
      if (data?.urls?.web_url) {
        window.location.href = data.urls.web_url;
      } else {
        sendNotfication(
          "Payment URL is missing! Please contact support.",
          "danger",
          "bottom-left"
        );
      }
    } catch (error) {
      console.error("Error during gateway deposit:", error);
      sendNotfication(
        "An unexpected error occurred! Please try again later.",
        "danger",
        "bottom-left"
      );
    } finally {
      setLoading(false); // Reset loading state in all cases
    }
  };
  const handleGatewayDeposit = async (event) => {
    event.preventDefault(); // Prevent form submission default behavior
    setLoading(true); // Set loading to true to indicate process start

    try {
      // Sending POST request to the API
      const response = await axios.post(
        "https://api.betbazaar365.com/payment/api/paynow/upi",
        {
          money: parseFloat(amount),
          uid: getUID || parseFloat(Cookies.get("uid")),
        }
      );

      const data = response?.data;

      // Check if response data is valid
      if (!data) {
        alertMessage("Something went wrong! Please try again.");
        setLoading(false); // Reset loading state
        return;
      }

      // Handle error status from the API
      if (data?.status === false) {
        alertMessage(data?.message || "Payment failed! Please try again.");
        setLoading(false); // Reset loading state
        return;
      }

      // Redirect to the provided web URL
     if (data?.payment_link || data?.status) {
        window.location.href = data?.payment_link;
      } else {
        sendNotfication(
          "Payment URL is missing! Please contact support.",
          "danger",
          "bottom-left"
        );
      }
    } catch (error) {
      console.error("Error during gateway deposit:", error);
      sendNotfication(
        "An unexpected error occurred! Please try again later.",
        "danger",
        "bottom-left"
      );
    } finally {
      setLoading(false); // Reset loading state in all cases
    }
  };
  const handleManualDeposit = async (event) => {
    event.preventDefault(); // Prevent form submission default behavior
    setLoading(true); // Set loading to true to indicate process start

    try {
      // Sending POST request to the API
      const response = await axios.post(
        "https://api.betbazaar365.com/payment/api/paynow/manual",
        {
          money: parseFloat(amount),
          uid: getUID || parseFloat(Cookies.get("uid")),
          utrNumber: utrNumber,
        }
      );

      const data = response?.data;

      // Check if response data is valid
      if (!data) {
        alertMessage("Something went wrong! Please try again.");
        setLoading(false); // Reset loading state
        return;
      }

      // Handle error status from the API
      if (data?.status === false) {
        alertMessage(data?.message || "Payment failed! Please try again.");
        setLoading(false); // Reset loading state
        return;
      }

      // Redirect to the provided web URL
      if (data.status === true) {
        sendNotfication(data.message, "success", "bottom-left");
      } else {
        sendNotfication(
          "Payment URL is missing! Please contact support.",
          "danger",
          "bottom-left"
        );
      }
    } catch (error) {
      console.error("Error during gateway deposit:", error);
      sendNotfication(
        "An unexpected error occurred! Please try again later.",
        "danger",
        "bottom-left"
      );
    } finally {
      setLoading(false); // Reset loading state in all cases
    }
  };

  return (
    <Container1
      style={{ padding: "20px", maxWidth: "600px", margin: "0 auto" }}
    >
      <div style={{ width: "100%", textAlign: "center" }}>
        <h4>Select Deposit Type</h4>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "10px",
            marginBottom: "20px",
          }}
        >
          <Button
            onClick={() => setDepositType("manual")}
            style={{ padding: "10px 20px", fontSize: "16px" }}
          >
            Manual Deposit
          </Button>
          <Button
            onClick={() => setDepositType("online")}
            style={{ padding: "10px 20px", fontSize: "16px" }}
          >
            Online Deposit
          </Button>
          <Button
            onClick={() => setDepositType("gateway")}
            style={{ padding: "10px 20px", fontSize: "16px" }}
          >
            UPI Gateway
          </Button>
        </div>

        {depositType === "manual" ? (
          step === 1 ? (
            <form
              onSubmit={handleSubmitAmount}
              style={{ display: "flex", flexDirection: "column", gap: "15px" }}
            >
              <Form.Group>
                <Label style={{ fontSize: "16px", marginBottom: "8px" }}>
                  Amount:
                </Label>
                <Input
                  type="text"
                  value={amount}
                  onChange={handleAmountChange}
                  placeholder="Enter amount"
                  required
                  min={500}
                  max={49000}
                  style={{
                    padding: "10px",
                    fontSize: "14px",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                  }}
                />
              </Form.Group>
              <Button
                type="submit"
                style={{
                  padding: "12px 20px",
                  fontSize: "16px",
                  borderRadius: "8px",
                  backgroundColor: "#007bff",
                  color: "#fff",
                }}
              >
                Continue to Payment
              </Button>
            </form>
          ) : (
            <form
              onSubmit={handleSubmitDeposit}
              style={{ display: "flex", flexDirection: "column", gap: "15px" }}
            >
              <Form.Group>
                <Label style={{ fontSize: "16px", marginBottom: "8px" }}>
                  Scan QR code or enter UTR Number
                </Label>
                <img
                  src={`https://api.betbazaar365.com/uploads/${depositPaymentSetting?.qr_img}`}
                  alt="Scan QR Code"
                  style={{
                    width: "250px",
                    height: "200px",
                    objectFit: "contain",
                    margin: "0 auto",
                  }}
                />
                <p style={{ fontSize: "14px", textAlign: "center" }}>
                  Scan the QR code above to make the payment or enter UTR below
                  to confirm:
                </p>
                <Label style={{ fontSize: "16px", marginBottom: "8px" }}>
                  UTR Number:
                </Label>
                <Input
                  type="text"
                  value={utrNumber}
                  onChange={handleUtrChange}
                  placeholder="Enter UTR number"
                  required
                  style={{
                    padding: "10px",
                    fontSize: "14px",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                  }}
                />
              </Form.Group>
              <Button
                type="button"
                onClick={handleManualDeposit}
                style={{
                  padding: "12px 20px",
                  fontSize: "16px",
                  borderRadius: "8px",
                  backgroundColor: "#28a745",
                  color: "#fff",
                }}
              >
                {loading ? "Processing..." : "Submit Deposit"}
              </Button>
            </form>
          )
        ) : depositType === "gateway" ? (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "15px" }}
          >
            <Label style={{ fontSize: "16px", marginBottom: "8px" }}>
              Amount:
            </Label>
            <Input
              type="text"
              value={amount}
              onChange={handleAmountChange}
              placeholder="Enter amount for gateway deposit"
              required
              style={{
                padding: "10px",
                fontSize: "14px",
                borderRadius: "8px",
                border: "1px solid #ccc",
              }}
            />
            <Button
              onClick={handleGatewayDeposit}
              style={{
                padding: "12px 20px",
                fontSize: "16px",
                borderRadius: "8px",
                backgroundColor: "#17a2b8",
                color: "#fff",
              }}
            >
              {loading ? "Processing..." : "Proceed to Gateway Payment"}
            </Button>
          </div>
        ) : (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "15px" }}
          >
            <Label style={{ fontSize: "16px", marginBottom: "8px" }}>
              Amount:
            </Label>
            <Input
              type="text"
              value={amount}
              onChange={handleAmountChange}
              placeholder="Enter amount for online deposit"
              required
              style={{
                padding: "10px",
                fontSize: "14px",
                borderRadius: "8px",
                border: "1px solid #ccc",
              }}
            />
            <Button
              onClick={handleIndianPayGatewayDeposit}
              style={{
                padding: "12px 20px",
                fontSize: "16px",
                borderRadius: "8px",
                backgroundColor: "#17a2b8",
                color: "#fff",
              }}
            >
              {loading ? "Processing..." : "Proceed to Online Payment"}
            </Button>
          </div>
        )}
      </div>
    </Container1>
  );
};

const WithdrawalModel = () => {
  const [amount, setAmount] = useState("");
  const [utrNumber, setUtrNumber] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [bankname, setBankName] = useState("");
  const [loading, setLoading] = useState(false);
  const [transactionType, setTransactionType] = useState("manual"); // Default is manual

  // Handle socket connection and submission
  useEffect(() => {
    socket.on(C.SUBMIT_MANUAL_WITHDRAWL, (data) => {
      const decodedData = decode(data);
      if (decodedData?.status === true) {
        setTimeout(() => {
          sendNotfication(decodedData?.msg, "success", "bottom-left");
        }, 1000);
      } else {
        setTimeout(() => {
          sendNotfication(decodedData?.msg, "error", "bottom-left");
        }, 1000);
      }
      setLoading(false);
    });
    socket.on(C.SUBMIT_ONLINE_WITHDRAWL, (data) => {
      const decodedData = decode(data);
      console.log(decodedData.message);
      if (decodedData?.message?.status == 200) {
        setTimeout(() => {
          sendNotfication(
            decodedData?.message?.success,
            "success",
            "bottom-left"
          );
        }, 1000);
      } else {
        sendNotfication(decodedData?.message?.error, "error", "bottom-left");
      }
      setLoading(false);
    });

    // Clean up the socket listener on component unmount
    return () => {
      socket.off(C.SUBMIT_MANUAL_WITHDRAWL);
      socket.off(C.SUBMIT_ONLINE_WITHDRAWL);
      setLoading(false);
    };
  }, []);

  const handleAmountChange = (event) => {
    setAmount(event.target.value);
  };

  const handleUtrChange = (event) => {
    setUtrNumber(event.target.value);
  };

  const handleAccountNumberChange = (event) => {
    setAccountNumber(event.target.value);
  };

  const handleIfscCodeChange = (event) => {
    setIfscCode(event.target.value);
  };

  const handlebanknameChange = (event) => {
    setBankName(event.target.value);
  };

  const handleTransactionTypeChange = (event) => {
    setTransactionType(event.target.value);
  };

  function generateTransactionId(phoneNumber) {
    const seed = Date.now();
    const combinedString = String(phoneNumber) + seed;
    const hashCode = combinedString.split("").reduce((hash, char) => {
      return (hash << 5) - hash + char.charCodeAt(0);
    }, 0);
    return Math.abs(hashCode % 100000000)
      .toString()
      .padStart(8, "0");
  }

  order_id = generateTransactionId(getUID || parseFloat(Cookies.get("uid")));

  const handleSubmit = async (event) => {
    // Check if value is a valid number and within the required range
    if (amount && (parseFloat(amount) < 500 || parseFloat(amount) > 49000)) {
      setLoading(false);
      // Optionally, you could set an error state here
      sendNotfication(
        "Amount must be between 500 and 49,000",
        "success",
        "bottom-left"
      );
      return;
    } else {
      setAmount(amount);
    }

    setLoading(true);
    event.preventDefault();

    if (transactionType === "manual") {
      try {
        // Sending POST request to the API
        const response = await axios.post(
          "https://api.betbazaar365.com/payment/api/withdrawal/manual",
          {
            money: parseFloat(amount),
            uid: String(getUID),
            upiId: utrNumber,
          }
        );

        const data = response?.data;

        // Check if response data is valid
        if (!data) {
          alertMessage("Something went wrong! Please try again.");
          setLoading(false); // Reset loading state
          return;
        }

        // Handle error status from the API
        if (data?.status === false) {
          alertMessage(data?.message || "Payment failed! Please try again.");
          setLoading(false); // Reset loading state
          return;
        }

        // Redirect to the provided web URL
        if (data.status === true) {
          sendNotfication(data.message, "success", "bottom-left");
        } else {
          sendNotfication(
            "Payment URL is missing! Please contact support.",
            "danger",
            "bottom-left"
          );
        }
      } catch (error) {
        console.error("Error during gateway deposit:", error);
        sendNotfication(
          "An unexpected error occurred! Please try again later.",
          "danger",
          "bottom-left"
        );
      } finally {
        setLoading(false); // Reset loading state in all cases
      }
    } else if (transactionType === "online") {
      const data = {
        amount: parseFloat(amount),
        account_no: accountNumber,
        ifsccode: ifscCode,
        bankname: bankname, // Use dynamic data if needed
        orderid: order_id,
        req_type: "withdrawal",
        status: "pending",
        transaction_type: "online",
      };

      console.log(data);

      // Emit the socket event for online withdrawal
      socket.emit(C.SUBMIT_ONLINE_WITHDRAWL, encode(data));
    }
  };

  return (
    <Container1
      style={{ padding: "20px", maxWidth: "600px", margin: "0 auto" }}
    >
      <div style={{ width: "100%" }}>
        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: "20px" }}
        >
          <Label style={{ fontSize: "16px", marginBottom: "8px" }}>
            Payment Mode:
          </Label>
          <select
            value={transactionType}
            onChange={handleTransactionTypeChange}
            required
            style={{
              padding: "10px 14px",
              fontSize: "14px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              backgroundColor: "#f9f9f9",
              width: "100%",
              maxWidth: "300px",
              marginBottom: "4px", // Add space between select and next elements
            }}
          >
            <option value="manual" style={{ fontSize: "14px" }}>
              Manual Withdrawal
            </option>
            <option value="online" style={{ fontSize: "14px" }}>
              Online Withdrawal
            </option>
          </select>

          <Label style={{ fontSize: "16px", marginBottom: "0px" }}>
            Amount:
          </Label>
          <Input
            type="text"
            value={amount}
            onChange={handleAmountChange}
            placeholder="Enter amount"
            required
            style={{
              padding: "10px",
              fontSize: "14px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              backgroundColor: "#f9f9f9",
            }}
          />

          {transactionType === "manual" ? (
            <>
              <Label style={{ fontSize: "16px", marginBottom: "0px" }}>
                UPI Id:
              </Label>
              <Input
                type="text"
                value={utrNumber}
                onChange={handleUtrChange}
                placeholder="Enter UPI Id"
                required
                style={{
                  padding: "10px",
                  fontSize: "14px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  backgroundColor: "#f9f9f9",
                }}
              />
            </>
          ) : (
            <>
              <Label style={{ fontSize: "16px", marginBottom: "8px" }}>
                Bank Name:
              </Label>
              <Input
                type="text"
                value={bankname}
                onChange={handlebanknameChange}
                placeholder="Enter Bank Name"
                required
                style={{
                  padding: "10px",
                  fontSize: "14px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  backgroundColor: "#f9f9f9",
                }}
              />

              <Label style={{ fontSize: "16px", marginBottom: "0px" }}>
                Account Number:
              </Label>
              <Input
                type="text"
                value={accountNumber}
                onChange={handleAccountNumberChange}
                placeholder="Enter Account Number"
                required
                style={{
                  padding: "10px",
                  fontSize: "14px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  backgroundColor: "#f9f9f9",
                }}
              />

              <Label style={{ fontSize: "16px", marginBottom: "0px" }}>
                IFSC Code:
              </Label>
              <Input
                type="text"
                value={ifscCode}
                onChange={handleIfscCodeChange}
                placeholder="Enter IFSC Code"
                required
                style={{
                  padding: "10px",
                  fontSize: "14px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  backgroundColor: "#f9f9f9",
                }}
              />
            </>
          )}

          <Button
            type="submit"
            style={{
              padding: "12px 20px",
              fontSize: "16px",
              borderRadius: "8px",
              backgroundColor: "#007bff",
              color: "#fff",
              textAlign: "center",
            }}
          >
            {loading ? "Processing..." : "Submit Withdrawal"}
          </Button>
        </form>
      </div>
    </Container1>
  );
};

class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transactionType: "deposit", // Default to deposit
      amount: "",
      upiNumber: "",
      utrNumber: "",
      isModalOpenDeposit: false,
      isModalOpenWithdrawal: false,
    };
  }

  toggleModalDeposit = () => {
    this.setState((prevState) => ({
      isModalOpenDeposit: !prevState.isModalOpenDeposit,
    }));
  };
  toggleModalWithdrawal = () => {
    this.setState((prevState) => ({
      isModalOpenWithdrawal: !prevState.isModalOpenWithdrawal,
    }));
  };

  render() {
    const {
      transactionType,
      amount,
      upiNumber,
      utrNumber,
      isModalOpenDeposit,
      isModalOpenWithdrawal,
    } = this.state;

    return (
      <Container>
        {/* deposit */}
        <StyledModal
          show={isModalOpenDeposit}
          onHide={this.toggleModalDeposit}
          centered
        >
          <ModalHeader>
            <div style={{ fontSize: "16px", fontWeight: "bold" }}>Deposit</div>

            <X onClick={this.toggleModalDeposit} size={24} />
          </ModalHeader>
          <ModalBody>
            <DepositModel />
          </ModalBody>
        </StyledModal>

        {/* withdrawal */}
        <StyledModal
          show={isModalOpenWithdrawal}
          onHide={this.toggleModalWithdrawal}
          centered
        >
          <ModalHeader>
            <div style={{ fontSize: "16px", fontWeight: "bold" }}>
              Withdrawal
            </div>

            <X onClick={this.toggleModalWithdrawal} size={24} />
          </ModalHeader>
          <ModalBody>
            <WithdrawalModel />
          </ModalBody>
        </StyledModal>

        <ModalContent />
      </Container>
    );
  }
}

export default Payment;
